import { render } from "./SettingsEmailsTemplatesForm.vue?vue&type=template&id=e25dc368&scoped=true"
import script from "./SettingsEmailsTemplatesForm.vue?vue&type=script&lang=js"
export * from "./SettingsEmailsTemplatesForm.vue?vue&type=script&lang=js"

import "./SettingsEmailsTemplatesForm.vue?vue&type=style&index=0&id=e25dc368&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e25dc368"]])

export default __exports__